import { Component, Input } from '@angular/core';
import { FactorIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { CommonModule } from '@angular/common';
import { WucBalloonModule, WucDisplayFieldModule, WucRackModule } from '@inshared/website-ui-components';
import {
    InsurancePremiumDeterminingFactorDataComponent,
    InsurancePremiumDeterminingFactorFormComponent,
    InsurancePremiumDeterminingFactorFutureComponent,
} from './';
import { Observable } from 'rxjs';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';

@Component({
    selector: 'ins-insurance-premium-determining-factors',
    standalone: true,
    imports: [
        CommonModule,
        WucRackModule,
        WucBalloonModule,
        InsurancePremiumDeterminingFactorDataComponent,
        InsurancePremiumDeterminingFactorFutureComponent,
        InsurancePremiumDeterminingFactorFormComponent,
        WucDisplayFieldModule,
    ],
    templateUrl: './insurance-premium-determining-factors.component.html',
})
export class InsurancePremiumDeterminingFactorsComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    public selectedFactorIds: FactorIdEnum[] = [];
    public isScreenSmall$: Observable<boolean> = this.intersectionObserverService.isScreenSmall$;

    public selectFactor(factorId: FactorIdEnum) {
        this.selectedFactorIds.push(factorId);
    }

    public deselectFactor(factorId: FactorIdEnum): void {
        this.selectedFactorIds = this.selectedFactorIds.filter((id) => factorId !== id);
    }
    constructor(public intersectionObserverService: IntersectionObserverService) {}
}
